export const dataTop = [
  {
    name: "Potatoes",
    photo_url: "https://rare-gallery.com/thumbs/874731-Potato-Closeup-Many.jpg",
    quantity: "One container",
    id: 20,
    price: 80,
  },
  {
    name: "Pumpkin",
    photo_url:
      "https://images.wallpaperscraft.com/image/single/pumpkin_vegetable_autumn_187924_3840x2160.jpg",
    quantity: "One container",
    id: 21,
    price: 80,
  },
  {
    name: "Bitter gourd",
    photo_url:
      "https://c1.wallpaperflare.com/preview/672/466/385/baby-bitter-gourd-pile-green-gourd-bitter-gourd-food.jpg",
    quantity: "One container",
    id: 22,
    price: 80,
  },
  {
    name: "Bottle gourd",
    photo_url:
      "https://c1.wallpaperflare.com/preview/313/701/167/gourd-bottle-green-long.jpg",
    quantity: "One container",
    id: 23,
    price: 80,
  },
];
